import * as React from 'react';
import Wrapper from './Wrapper';

const LearningJourney = Wrapper(props => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 4.16669L1.33331 7.96408L10.5 11.3406L19.6666 7.96408L10.5 4.16669Z"
      stroke="#292933"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33331 8.15222V12.9348"
      stroke="#292933"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.50001 10V14.0969C5.49829 14.5019 5.74718 14.8669 6.12801 15.0179L10.128 16.5967C10.367 16.69 10.633 16.69 10.872 16.5967L14.872 15.0179C15.2528 14.8669 15.5017 14.5019 15.5 14.0969V10"
      stroke="#292933"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

export default LearningJourney;
